import React from "react";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import styles from "./costcalculator.module.scss";

export const CostCalculator = () => {
  return (
    <div className={styles.left_wrapper}>
      <h2 className={styles.cost_of_title}>
        Cost Of Living <br /> <span className="mark">Calculator</span>{" "}
      </h2>

      <ReactSVG
        src={getAssets("assets/images/country/cost_of_illustration.svg")}
      />
    </div>
  );
};

export default CostCalculator;
